module.exports = "./dist/dmap/leaflet/marker-icon.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/marker-icon.png
// module id = 48
// module chunks = 4